import React from 'react'
import TeamListCmp from './TeamList'
import Employees from '../../../api/Employees'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'

const api = new Employees()

function TeamListContainer () {
  const { fetching, fetch, list: cached } = useFetchList(api.list)
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  return <TeamListCmp {...{ fetching, fetch, list, company, onChangeCompany }} />
}

export default TeamListContainer
